import { motion } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import icon1 from '@/assets/icon1.svg';
import icon2 from '@/assets/icon2.svg';
import icon3 from '@/assets/icon3.svg';

const services = [
  {
    icon: icon1,
    alt: 'ícone de gestão de contratos',
    title: 'Gestão de Contratos',
    description: 'Crie, organize e acompanhe todos os seus contratos em um só lugar, com controle completo do ciclo de vida e vencimentos.',
    items: [ 'Controle de vencimentos', 'Histórico completo de alterações'],
  },
  {
    icon: icon2,
    alt: 'ícone de dashboard',
    title: 'Dashboard Completo',
    description: 'Acompanhe todos os seus clientes e contratos em tempo real, com indicadores financeiros e alertas de inadimplência.',
    items: ['Indicadores financeiros em tempo real', 'Visão de contratos ativos', 'Relatórios de faturamento'],
  },
  {
    icon: icon3,
    alt: 'ícone de CRM',
    title: 'CRM e notificações',
    description: 'Automatize cobranças, renovações e comunicações com seus clientes por meio de notificações inteligentes e programadas.',
    items: ['Alertas de vencimento automáticos', 'Cobranças programadas', 'Notificações por e-mail'],
  },
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.15 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const OurServices = () => {
  return (
    <section id="servicos" className="min-h-screen flex items-center bg-[#faf8ff] px-6 py-20">
      <div className="max-w-6xl mx-auto w-full">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          viewport={{ once: true }}
        >
          <h2 className="text-[--primary-color] font-bold text-4xl md:text-5xl uppercase tracking-tight mb-4">
            Nossos Serviços
          </h2>
          <p className="text-[--terciary-color] text-lg font-light leading-relaxed max-w-2xl mx-auto">
            Soluções completas para cada etapa do ciclo de vida dos seus contratos
          </p>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-6"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {services.map((service) => (
            <motion.div
              key={service.title}
              variants={cardVariants}
              className="group bg-white border border-gray-100 rounded-2xl p-8 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-default"
            >
              <div className="w-14 h-14 bg-[#f3e8ff] rounded-xl flex items-center justify-center mb-6 group-hover:bg-[--secondary-color] transition-colors duration-300">
                <img className="w-7 h-7" src={service.icon} alt={service.alt} />
              </div>

              <h3 className="text-[--primary-color] font-bold text-xl mb-3">
                {service.title}
              </h3>

              <p className="text-gray-500 text-sm font-normal leading-relaxed mb-6">
                {service.description}
              </p>

              <ul className="space-y-2">
                {service.items.map((item) => (
                  <li key={item} className="flex items-center gap-2 text-sm text-[--terciary-color] font-medium">
                    <CheckCircleIcon sx={{ fontSize: 16, color: '#CB88F9' }} />
                    {item}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default OurServices;

